import { Grid, Paper, Typography, makeStyles } from '@material-ui/core'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({
  iframe: {
    border: 'none',
    outline: 'none'
  },
  noCatalog: {
    color: '#e60017',
    fontSize: 16,
    marginTop: 30,
    marginBottom: 30,
    width: '100%',
    textAlign: 'center'
  }
}))

const GeneralCatalog = () => {
  const classes = useStyles()
  const providerSelected = useSelector((state) => state.provider)

  return (
    <Paper style={{ padding: 16 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Typography color="secondary">CATÁLOGO GENERAL</Typography>
        </Grid>
        {providerSelected.urlCatalog && providerSelected.urlCatalog !== '' ? (
          <iframe
            className={classes.iframe}
            src={providerSelected.urlCatalog}
            width="100%"
            height="800px"
            title="General Catalog PDF"
            seamless="seamless"
            scrolling="no"
            allowFullScreen={true}
          />
        ) : (
          <div className={classes.noCatalog}>No hay ningún catálogo disponible</div>
        )}
      </Grid>
    </Paper>
  )
}

export default GeneralCatalog
